// Types
import { EMRExamType } from "src/services/emr/types";

export const EXAM_TYPE_ORDER: Array<EMRExamType> = [
  "Oct",
  "Fundus",
  "AnteriorSegment",
  "VisualField",
  "Other",
];

export const EXAM_TYPE_LABELS: Record<EMRExamType, string> = {
  Oct: "OCT",
  Fundus: "Fundus",
  AnteriorSegment: "Anterior Segment",
  VisualField: "Visual Field",
  Other: "Other",
};

export const sortExamTypes = (examTypes: Array<EMRExamType>) =>
  EXAM_TYPE_ORDER.filter((examType) => examTypes.includes(examType));

export const defaultExamTypes = (examTypes: Array<EMRExamType>) => {
  const withoutOther = examTypes.filter((examType) => examType !== "Other");
  return sortExamTypes(withoutOther.length > 0 ? withoutOther : examTypes);
};

export const describeExamTypes = (
  examTypes: Array<EMRExamType> | undefined,
  t: (key: string) => string
) =>
  sortExamTypes(examTypes ?? [])
    .map((examType) => t(EXAM_TYPE_LABELS[examType]))
    .join(", ");
